import {leerFiltrosPorColumna, type OpcionesDeColumna, type TipoDeFiltroDeColumna} from '@cnc/contracts';
import type {Texto} from '../i18n/idioma';

export type ColumnaConFiltro = {id: string; titulo: Texto | string; tipo: TipoDeFiltroDeColumna};
// Pide los valores de una columna (solo cuando la lista se abre).
export type UseOpcionesDeColumna = (
  columna: string,
  contiene: string,
  habilitado: boolean,
) => {data?: OpcionesDeColumna; isFetching: boolean};

// Las columnas de la tabla que llevan filtro (7/10/2026): las visibles que
// estan en la lista de su pantalla (las que ya tienen filtro fijo no estan),
// y siempre las que tienen un filtro puesto aunque se haya quitado la columna.
export function columnasConFiltro<C extends {id: string; titulo: Texto | string}>(
  visibles: readonly string[],
  todas: readonly C[],
  tipos: Readonly<Record<string, TipoDeFiltroDeColumna>>,
  porColumna: string | undefined,
): ColumnaConFiltro[] {
  const puestos = Object.keys(leerFiltrosPorColumna(porColumna));
  const ids = [...visibles, ...puestos.filter(id => !visibles.includes(id))];
  return ids.flatMap(id => {
    const tipo = tipos[id];
    const columna = todas.find(c => c.id === id);
    return tipo && columna ? [{id, titulo: columna.titulo, tipo}] : [];
  });
}
